import React, { useEffect, useState } from 'react';
import './ApplicationsPage.css';
import moment from 'moment';

function ApplicationsPage({ credentials, applications }) {
  return (
    <div className='cred-dashboard-content'>
      <div className='dashboard-header'>
        <h1>Admin Dashboard Users</h1>
      </div>
      <table className='table'>
        <thead className='thead-light'>
          <tr>
            <th scope='col'>#</th>
            <th scope='col'>Name</th>
            <th scope='col'>Seats</th>
            <th scope='col'>Active Sessions</th>
            <th scope='col'>Total Sessions</th>
            <th scope='col'>Created At</th>
          </tr>
        </thead>
        <tbody>
          {applications.map((app, index) => {
            return (
              <tr key={`app-${index}`}>
                <th scope='row'>{index + 1}</th>
                <td>{app.name}</td>
                <td>
                  {
                    credentials.filter((c) => c.application_id === app.id)
                      .length
                  }
                </td>
                <td>{app.active_sessions}</td>
                <td>{app.total_sessions}</td>
                <td>{moment(app.createdAt).format('MMM Do YY')}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ApplicationsPage;
